window.onLoadCaptchaV3Callback = e => {
    return e;
};
